module.exports = __webpack_public_path__ + "static/img/solution-4.d5c14800.png";